<div class="task-modal-group">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <span class="bold-item redirect pr-2">
            Ir a
            <a class="text-manax cursor-pointer" (click)="redirectToCalendar()">
              Agenda
            </a>
          </span>
          <button mat-icon-button type="button" (click)="closeModal()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal" #top>
          Trabajo
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <!-- body content -->
  <div *ngIf="!loading && readOnly">
    <div class="row font-manax split-border">
      <div class="col-12 col-md-8">
        <div class="row px-3 pb-3 text-purple-manax bold-item" style="font-size: 2rem;">{{task.client?.firstname}}
          {{task.client?.lastname}}
        </div>
        <div class="row px-3 pb-2 text-purple-manax bold-item" style="font-size: 1.5rem;">{{task.title}}</div>
        <div class="row px-3 pb-2 bold-item">Categoría:
          <span class="normal-item">&nbsp;{{task.category?.[0]?.name}}</span>
        </div>
        <div class="row px-3 pb-2 bold-item" *ngIf="task?.description">Instrucciones:
          <span class="normal-item">&nbsp;{{task.description}}</span>
        </div>
        <div class="row px-3 pb-2 bold-item">Ubicación:
          <span class="normal-item">&nbsp;{{task.location}}</span>
        </div>
        <div class="row px-3 pb-2 bold-item" *ngIf="filteredWorkers.length > 0">Trabajadores:
          <span *ngFor="let worker of filteredWorkers; let isLast=last" class="normal-item">
            &nbsp;{{worker?.firstname}} {{worker?.lastname}}{{!isLast ? ', ' : ''}}
          </span>
        </div>
      </div>
      <div class="col-12 col-md-4 split-border-detail">
        <div class="row px-3 pb-1 pb-md-3 text-purple-manax bold-item" style="font-size: 2rem;">&nbsp;</div>
        <div class="row px-3 pb-2 bold-item" style="font-size: 1.5rem;">Detalles</div>
        <div class="row px-3 pb-2 bold-item">Tipo de Trabajo:
          <span class="normal-item">&nbsp;{{task.appointment?.schedule ? 'Recurrente' : 'Eventual'}}</span>
        </div>


        <div class="row px-3 pb-2 bold-item">Inicio:
          <span class="normal-item">&nbsp;{{startDate}}</span>
        </div>
        <div class="row px-3 pb-2 bold-item">Fin:
          <span class="normal-item">&nbsp;{{untilDate}}</span>
        </div>


        <div class="row px-3 pb-2 bold-item" *ngIf="recuFreq">Programación:
          <span class="normal-item">&nbsp;{{recuFreq}}</span>
          <span class="normal-item" *ngIf="recuDay && !recuInterval">&nbsp;Los {{recuDay}} de cada mes</span>
          <span class="normal-item" *ngIf="recuDay && recuInterval">&nbsp;Los días {{recuDay}} cada {{recuInterval}}
            meses</span>
          <span class="normal-item" *ngIf="recuWeek && !recuInterval">&nbsp;{{ recuWeek.join(', ') }}</span>
          <span class="normal-item" *ngIf="recuWeek && recuInterval">&nbsp;{{ recuWeek.join(', ') }} cada
            {{recuInterval}} semanas</span>

        </div>

      </div>
    </div>

    <div class="row split-border my-3">
      <div class="col-12">
        <h5 class="m-0 title-section">
          Facturación
        </h5>
      </div>

      <div class="col-12">
        <!-- taxPercentage: for compatibility with old tasks -->
        <app-detail-list [items]="detailItems" (listChange)="onListChange($event)"
          [readOnly]="!!task.serviceAgreement || readOnly" [pricing]="!task.serviceAgreement?._id"
          [taxPercentage]="task.taxPercentage ?? 0"></app-detail-list>
      </div>
    </div>



    <div class="row my-3">
      <div class="col-12">
        <h5 class="m-0 pt-3 title-section">
          Visitas
        </h5>
      </div>

      <div class="col-12">
        <div class="row">
          <table class="table table-hover m-0 align-top">
            <tbody>

              <tr (click)="openEditTaskModal(task)" *ngIf="!haveRecurrence">
                <td>
                  {{startDateTime}}
                </td>
                <td>
                  <span class="status-pill status-label"
                    [ngStyle]="{'background-color': taskStatusColors[f['status'].value] || taskStatusColors.DEFAULT}"
                    *ngIf="action !== 'Crear'">
                    {{taskStatuses[f['status'].value]}}
                  </span>
                </td>
                <td class="text-right">
                  <div *ngIf="task?.workers && task?.workers?.length === 0">
                    Sin Trabajador Asignado
                  </div>
                  <div *ngIf="task?.workers && filteredWorkers.length > 0">
                    Asignado a
                    <span *ngFor="let worker of filteredWorkers; let isLast=last">
                      &nbsp;{{worker?.firstname}} {{worker?.lastname ? worker?.lastname : ""}}{{!isLast ? ', ' : ''}}
                    </span>
                  </div>
                </td>
              </tr>


              <tr *ngFor="let appo of nextAppointments" class='cursor-pointer' (click)="openEditTaskModal(appo?.task)">
                <td>
                  {{appo?.startDateTime}}
                </td>
                <td>
                  <span class="status-pill status-label"
                    [ngStyle]="{'background-color': taskStatusColors[appo?.task?.status] || taskStatusColors.DEFAULT}"
                    *ngIf="action !== 'Crear'">
                    {{taskStatuses[appo?.task?.status]}}
                  </span>
                </td>
                <td class="text-right">
                  <div *ngIf="!hasActiveWorkers(appo?.workers)">
                    Sin Trabajador Asignado
                  </div>
                  <div *ngIf="hasActiveWorkers(appo?.workers)">
                    Asignado a
                    <span *ngFor="let worker of getActiveWorkers(appo?.workers); let isLast=last">
                      &nbsp;{{worker?.firstname}} {{worker?.lastname}}{{!isLast ? ', ' : ''}}
                    </span>
                  </div>
                </td>
              </tr>



              <tr *ngIf="thereAreMore && !loading" (click)='loadMore()' class="cursor-pointer">
                <td colspan="10">
                  <button class="btn btn-link text-purple-manax text-capitalize p-0">
                    + Cargar mas
                  </button>
                </td>
              </tr>


              <tr *ngIf="loading">
                <td colspan="10" class="text-center">
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</div>